/**
 * Maps a failed password change/reset request to a customer-facing i18n key.
 * Keyed by the stable API `code`, never by the raw API message.
 */
export const PASSWORD_ERROR_KEYS = {
    currentPasswordInvalid: "settings.password_errors.current_password_invalid",
    invalidPassword: "settings.password_errors.invalid_password",
    accountNotFound: "settings.password_errors.account_not_found",
    providerUnavailable: "settings.password_errors.provider_unavailable",
    network: "settings.password_errors.network",
    generic: "settings.password_errors.generic",
};
const KEYS_BY_API_CODE = {
    CURRENT_PASSWORD_INVALID: PASSWORD_ERROR_KEYS.currentPasswordInvalid,
    INVALID_PASSWORD: PASSWORD_ERROR_KEYS.invalidPassword,
    AUTH_ACCOUNT_NOT_FOUND: PASSWORD_ERROR_KEYS.accountNotFound,
    AUTH_PROVIDER_UNAVAILABLE: PASSWORD_ERROR_KEYS.providerUnavailable,
};
export function resolvePasswordErrorKey(error) {
    if (typeof error !== "object" || error === null) {
        return PASSWORD_ERROR_KEYS.generic;
    }
    const { isAxiosError, request, response } = error;
    if (!response) {
        return isAxiosError && request !== undefined
            ? PASSWORD_ERROR_KEYS.network
            : PASSWORD_ERROR_KEYS.generic;
    }
    const code = response.data?.code;
    return (typeof code === "string" && KEYS_BY_API_CODE[code]) || PASSWORD_ERROR_KEYS.generic;
}
export const passwordErrorService = { resolvePasswordErrorKey };
export default passwordErrorService;
